<div mat-dialog-title class="markdown-title">
  <h4><strong>{{ title }}</strong></h4>
</div>

<mat-dialog-content aria-label="Dialog Content">
  <div class="modal-body">
    <div>
      <div class="fs-17 mb-2">
        <p *ngFor="let paragraph of content" class="mb-2">{{ paragraph }}</p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" aria-label="Dialog Actions"
  class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
  <button 
    class="btn btn-primary order-2 order-md-1" 
    (click)="closeDialog()">
    Close
  </button>
</mat-dialog-actions>
